import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';

import VerbText from '../VerbText';

let timeoutId;

const FormFeedback = (props) => {
    const {
        submitting,
        submitSucceeded,
        modalSubmitSucceeded,
        hideSuccessMessage,
        submitFailed,
        failMsg,
        submittingMsg,
        successMsg,
        className,
        submitTemporary = false
    } = props;
    const [feedbackMessage, setFeedbackMessage] = useState('');

    useEffect(() => {
        if (submitting) {
            setFeedbackMessage(
                submittingMsg || <VerbText messageId={'RESET_PASS_SAVING'} defaultMessage={'Saving...'} />
            );
        }
        if (submitFailed && !submitting) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            setFeedbackMessage(
                failMsg || (
                    <VerbText messageId={'LOGIN_SIGN_UP_FAILED'} defaultMessage={'Sorry, something went wrong.'} />
                )
            );
        }
        if ((submitSucceeded || modalSubmitSucceeded) && !hideSuccessMessage) {
            setFeedbackMessage(successMsg || <VerbText messageId={'LOGIN_SUCCESS'} defaultMessage={'Success!'} />);
            if (submitTemporary) {
                timeoutId = setTimeout(() => {
                    setFeedbackMessage('');
                }, 1500);
            }
        } else if ((submitSucceeded || modalSubmitSucceeded) && hideSuccessMessage && !submitting) {
            setFeedbackMessage('');
        }
    }, [submitting, submitFailed, submitSucceeded, hideSuccessMessage, modalSubmitSucceeded]);

    return (
        <div className={cns('formMessages', className, { 'form-validation-error': submitFailed && !submitting })}>
            {feedbackMessage}
        </div>
    );
};

FormFeedback.propTypes = {
    submitting: PropTypes.bool.isRequired,
    submitSucceeded: PropTypes.bool.isRequired,
    submitFailed: PropTypes.bool.isRequired,
    submittingMsg: PropTypes.any,
    successMsg: PropTypes.any,
    failMsg: PropTypes.any,
    className: PropTypes.string,
    submitTemporary: PropTypes.bool,
    modalSubmitSucceeded: PropTypes.bool,
    hideSuccessMessage: PropTypes.bool
};

export default FormFeedback;
